import React, { useState } from 'react';
import CreateOrg from "home/CreateOrg";
import JoinOrg from "home/JoinOrg";
import WelcomeToDataPulseModal from "home/WelcomeToDataPulseModal";

export default function Onboarding(props) {

  let dpLogo = require("images/logos/datapulse-logo-blue-small.png");
  dpLogo = <img className="onboarding-logo" src={`/datapulse${dpLogo}`} />

  

  return (
    <>
      <div className="lite-onboarding-container">
        <div className="lite-onboarding-header">
          <h1>Welcome to {dpLogo}</h1>
          <p className="subheader">Looks like you don't have access to any organizations yet.</p>
        </div>
        <div className="lite-onboarding-content">
          <CreateOrg />
          <JoinOrg />
        </div>
        <div className="lite-onboarding-footer">
        <a href="mailto:datapulse@digitalposition.com" >Contact support</a>
        </div>
      </div>
      <WelcomeToDataPulseModal show={true} />
    </>
  )
}